import { SET_CURRENT_STORE, SET_PILOT_STORE, SET_REGIONAL_SELECTIONS } from '../actions/actionCreators';
import getThdStore from '../utils/getThdStoreInfo';

const { zipcode, storeNumber, isStoreEnabled } = getThdStore();
const initialState = {
  isStoreEnabled,
  storeNumber,
  zipcode,
  storeInfo: null,
  pilot: true,
  previousStoreId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_CURRENT_STORE: {
    if (action.payload.storeInfo?.storeFromDesign) {
      return action.payload.storeInfo.storeFromDesign;
    }
    if (action.payload.storeInfo?.persistedStore) {
      return action.payload.storeInfo.persistedStore;
    }
    return {
      ...state,
      isStoreEnabled: action.payload.isStoreEnabled,
      storeNumber: Number(action.payload.storeId),
      zipcode: Number(action.payload.zipcode),
      storeInfo: action.payload.storeInfo,
      previousStoreId: action.payload.previousStoreId || null,
    };
  }

  case SET_REGIONAL_SELECTIONS: {
    return {
      ...state,
      ...action.payload,
    };
  }

  // remove after POC
  case SET_PILOT_STORE: {
    return {
      ...state,
      pilot: action.payload,
    };
  }

  default:
    return state;
  }
};
